import { BaseEntity, ErrorResponse, FileType, LocalDate, NumberDate, Timestamp } from '@lemon/core/model/common'
import { PaymentRejection } from '@lemon/core/model/payment'
import { SelvitettavienNakyvyys, Yritysmuoto } from './kayttaja'
import { MobiiliKuittiKansikuva } from './mobiili-api'
import { PaymentDueType } from './tunnistaminen'

export const UUDEN_KUITIN_AVAIN = 'uusi'
export const MAXIMUM_AMOUNT = 9999999.99

export const MYYNTILASKU_MAKSUTAPA_ID = 9999
export const MYYNTILASKU_MAKSUTAPA: Maksutapa = {
  d: 1,
  i: MYYNTILASKU_MAKSUTAPA_ID,
  img: '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',
  l: 'Myyntilaskut',
  o: 1,
  v: 'Myyntilaskut',
  a: true,
}

export const MUU_MAKSUTAPA_ID = 9998
export const MUU_MAKSUTAPA: Maksutapa = {
  d: 1,
  i: MUU_MAKSUTAPA_ID,
  img: '',
  l: 'Muut tositteet',
  o: 1,
  v: 'Muut tositteet',
  a: true,
}

export const SAHKOISET_LASKUT_MAKSUTAPA_ID = 9997
export const SAHKOISET_LASKUT_MAKSUTAPA: Maksutapa = {
  d: 1,
  i: SAHKOISET_LASKUT_MAKSUTAPA_ID,
  img: 'iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAK50lEQVR4nO3dCawdVR3H8d9jKdBWWVQoBbVCK6hUEFzQBqMgohgJqLUsslREEIMRA6ISFwQRJYCQYAERrIIWF1xJQIyQiCEVo9JSKIJUoEIhLJbKVtoec/JO+969/5kzc++cuW8e8/0kE8j/3Jk303f+785y5n8EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACANhlq22/bOWdi49A+kj4j6U2SVkr6haTvSHqmjkMZGmpdN9mABBl/PhgSYtOuPb9e0sGSnk99RG1OkI1MBE32OknzM5LDe5+kI00UJEhLvFTSAklbRw73AyaCSkiQ8cGf43xf0hsL9nYTE0ElJMj48E1JHymxp0tNBJWQIM13hKTTSu7l7SaCSkiQZttT0iUl99DfnrvLRFEJCdJcLw8X5ZNL7uETku4zUVRCgjTTBEk/kTSjh71bJulJE0UlJEgzXSDpPT3u2Z0mgspIkOY5XtKJfezVYhNBZSRIs/gxVhf2uUckSA1IkOZ4paSrJW3Wxx6tlvRPE0VlJEgzTJL085AkMety2v4j6SETRWUkSDPMk/TWyJ74YexXhGcdWe6sYxQvSJAmOKXEKFx/0f4PSRublmG3mQiSIEHG1rslnVOwBz8KQ9xnmZYRd5gIkiBBxs40SVdFvhW8v0n6VBjN+wbTOsxfl9xtokiCBBkbk8NF+dTIT39M0mGSnpa0o6SdzSeGPSrpfhNFEiTI2LhU0l6Rn+xv2x4+6tbtLpK2MJ8a5sdfrTJRJEGCDN5pofPHfE7SjaPa806vxPVHvUiQwfKvxJ5d8BMvk3RxVyz2JuEiE0EyJMjgzJT0w4J/8z+Hcj7dYt8gS0wEycR+WUhnG0nXhP/meTBclHc/8NtS0k456/gHiPeaKEiQccTfor0ylOzJ4zv67JAk3aaFl6ey+M+vyIgjERKkfmdKOqjgp/hnHQtNdNiukQJ//vnHGhNFMiRIveZIOr3gJ5wXrk3yxC7QGeJeMxKkPm+TdHnB1m8oUbFkpomM4A5WzUiQekwpUXDBPwQ8StJa0zJik/CQMIujDlb9SJD0NgljrKZFtvxfSR8Ow0RipkTeEfHr/ttEkRQJkp6/ptivYKvHlnwCPr1giMlTJoqkSJC0jst50DfaGZKuNdFsu2VGh1HFZABIkHT2yxgi0s3P6/E1E80Xu4NFmdEBIEHS2DG82JQ1b8d6i8KpVS9eH/ks3yADQIJUNyEkx/aRLfmKh4eG6dLKmhwZYvIsVUwGgwSp7nxJ7yrYytw+Cku/StJ2JjrsnpxhKUiMCVeqOUnSpwu28GVJvzbRYrtG/oDdHepn5Q1BqWp1pMRQq5Ag/XtvqKEb8zNJZ0XaY2JP0PeveZj7c5L+GO64PW5a8eLlZ7lNsOzknFvh4hY65yZX+Fm/i259MG5xzr2szemQ9xWOfBPD1AR51wcKQ9D9Rfn/TEs5mxfcwRqUWWE4TGuRIL0rqoK4JhSCW2ZaytuyIAEHKXaq96JHgvTm9BJ/UU+V9AcT7c3KBr0Ixe3kNsk41y+7HFLirP97ia5x/HKM2frgLXbOTWlzf6nrNmFj+c7XB1804RZJW0VWvUnSAZJeMC39mxtuJe+Q8HflwlJ0Cue/xd7pRwAMDbWum2xAghTbMlQbiVUW8ZUN3y7pYdNSnf8dbZ3odNiFa6SLSpwq+nfkffVHtTlBWifjVCa2DDnnri04sXnWOfeOyDaatpxgjsA6Y/Q+o0V67Kznmq5jHZuxXlOXfZ1zq80RdFrQve8gQbKWI03Xsb6dsV5Tl2nOuYfMEXT6q3NuEgnSYiU771ucc0+b7tPpN+EULGv9pi2bO+duNUfQ6VHn3Iys/UaLZHWArmVb59y/TPfptNQPwchYt6nLfHMEndY6596ft+8gQdYvmzrnfm+6T6dVzrk9MtZt6vJFcwTWqbF9R4tkdYBRywWm61hHZ6zX1GV/59wacwSd5hftO0gQv8w1Xcc6O2O9pi5lRxxPJEGwQVYHcM7t7Zx7xnSfTr/MWK+py8TQ+WNWhCQqPAa0SEYHmOKcWxbpSN4S59zWGes2dVlgjqDTmnD6VWr/0d4E8bc/bzbdp9NK59zMrI7T0OUr5gisk3vZd7RI1y//ctN1OvlnIQdmdZqGLgebI7Au7nXf26zN76SfVKJOla+AuFzSm01L74bCYEFfU/eBGo7Hv4F4hYl2ulnSZ00UWC/8VSwzJsmV/EyvnnLOzXPObZb117rPZavw7kbM/c65HfrZPlrEOfca59yDkY40KOdldcY+lo2cc9cV7PNzzrlZ/f6MNmvjK7dHh1KhY+0TBZN6lnWOpAMLPntCeKcFPWpjgkw1kbHhK5e8pOJP/lh4Bz7mW5J+EGlHRBsT5AYTGRsPl5hAJ2YvSZdE2r3rJH3JRFFaGxPElwH9rokO3tJQhLofU8O865Mi6/pqJMdQQrSaNt7mXRPq6d4azt1j8whW4cLc6DNytnGbiZQzIRSu2zny6VWhcN1jpgWIybpLU+NypbmfNGJ2nz93ntlSp3XhgWHWutzF6hGF4+q1R87W1/U5Q+0JYYnx1eR/FWlHDyj7U5+p4Tog6zrhEUmv7XESzn1CxcYJpmXETyXNMdGK2lz2h2+Q+szISQ6Fur29JIefCvrqguTw30jHmygqIUHqE6vO3sv8gpuFi/K8+dIVqiDOCfOvIyESpD6xGWoXm0i+i8I0BHnWhWryi3LaUQEJUp9YqdI7TCSbvx39ycyWEb7i/G9NFEmQIPWYFHlO8VyYhLPIviWmePtxGIuFmpAg9YjNULu8RJHrGeG6Izbv+t+5KK8fCVKPXSRtnLPle8Issnn8k/0FkrbNaVdIsI9WmOINJZEg9ahygX6ZpD1NdISff+RwSfeaFiRHgtQjNq9f7G7TFyQdZqKdTg6vzmIASJD0/L/prpGt3mUiww6R9A0T7eS/XS42UdSGoSbpbReuM7Jehno8DDF5oiu+u6Q/5ayznn8jcD9Jz5uWmjHUBCntHOnoyzKSY5twUZ63zvr1Dh2L5Gg7EiS92BCT7tMr/6f5yoJTsmdCciw3LagdCZJe7A5W9wX6WZIOMp/qdKKkv5goBoIESa/sEJOjSrwvfr6k+SaKgSFB0tpC0vScLfqHg3eH/99b0qXmE52ul/R5E8VAkSBp+SHp2+ds8b4wn/qUcFG+ufnEiCWSjpC01rRgoEiQtKZHxk8tCUPTfY2qV5vWEU+H5Oi+24UxQIKktVtkawvDk/IDTEsn/8757SaKMdHm6u512Ctnm+vCQ779TUuncyVdZaIYMzxJT2fjcJcq9kwjxhe0+1ATC73xJB0pbFfw3njM4lBUmyqIDUOCpDM9UsUk5snwpHxl5DMYIyRIOrEHhHn8+d7He6xyggEiQdKJDTHJ81WqIDYbCZJOr98gvhDcmSaKRiFB0ohVMcnin4kclxFHw5AgacSqmHR7JLxW2+/cIBggEiSNWBWT0daEKojLTAsaiQRJY/eSWzlF0o0misYiQdLIG+I+mi+2cKGJotFIkDSKqqrfFMr1YJwhQdK4JrKVB8Lw9RdMCxqPBEnjFklfz9jSilAitKgWLxqK0bxp+YrssyW9IhRomB/eIhzX2jyaFwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIE7S/wHnpCG3gkewSQAAAABJRU5ErkJggg==',
  l: 'Sähköiset laskut',
  o: 1,
  v: 'Sähköiset laskut',
  a: true,
}

export const SAHKOISET_LASKUT_FAKE_MAKSUTAPA_ID = 9996
export const SAHKOISET_LASKUT_FAKE_MAKSUTAPA: Maksutapa = {
  d: 1,
  i: SAHKOISET_LASKUT_FAKE_MAKSUTAPA_ID,
  img: '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',
  l: 'Lemon Tree sähköpostilaskut',
  o: 1,
  v: 'Lemon Tree sähköpostilaskut',
  a: true,
}

export const AUTOMAATTISET_JAKSOTUKSET_ID = 9995
export const AUTOMAATTISET_JAKSOTUKSET: Maksutapa = {
  d: 1,
  i: AUTOMAATTISET_JAKSOTUKSET_ID,
  img: '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',
  l: 'Automaattiset jaksotukset',
  o: 1,
  v: 'Automaattiset jaksotukset',
  a: true,
}

export const MYYNTITOSITE_MAKSUTAPA_ID = 49
// export const MYYNTITOSITE_MAKSUTAPA_SQL_ID = 1279
export const MYYNTITOSITE_MAKSUTAPA: Maksutapa = {
  d: 1,
  i: MYYNTITOSITE_MAKSUTAPA_ID,
  img: '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',
  l: 'Myyntitositteet',
  o: 1,
  v: 'Myyntitositteet',
  a: true,
}

export const PALKKATOSITE_MAKSUTAPA_ID = 48
// export const PALKKATOSITE_MAKSUTAPA_SQL_ID = 1440
export const PALKKATOSITE_MAKSUTAPA: Maksutapa = {
  d: 1,
  i: PALKKATOSITE_MAKSUTAPA_ID,
  img: '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',
  l: 'Palkkamateriaali',
  o: 1,
  v: 'Palkkamateriaali',
  a: true,
}

export const TILIOTETOSITE_MAKSUTAPA_ID = 47
// export const TILIOTETOSITE_MAKSUTAPA_SQL_ID = 1441
export const TILIOTETOSITE_MAKSUTAPA: Maksutapa = {
  d: 1,
  i: TILIOTETOSITE_MAKSUTAPA_ID,
  img: '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',
  l: 'Tiliotteet',
  o: 1,
  v: 'Tiliotteet',
  a: true,
}

export interface KuitinUriRajaytettyna {
  /** Nykyään /r/, siis tässä muuttujassa ilman kenoja, eli w (niinq receipt) */
  alku: string
  asiakasId: number
  vuosi: number
  kuukausi: number
  avain: string
}

/** /r/{asiakasId}/selvitettavat */
export interface KuittiSelvitettava extends Kuitti {
  ym: number // Format: yymm
}

/** /r/{asiakasId}/{year}/{month} */
export interface Kuitti {
  /** Amount */
  a: number
  /** Day */
  d: number
  /** Explanation */
  e: string
  /** Payment method */
  p: number
  /** For sorting */
  s: number
  /** The alv percentage the user has given. */
  alv: number
  /** Images */
  i: { [key: string]: KuitinKuva }
  /** Versions to show the cloud in cell phones */
  v: string[]
  /** Is this receipt locked? */
  l?: true
  /** Is this receipt in reconsiliation (selvitettävä) */
  x?: true
  /** If this is marked to be in reconsiliation (selvitettävä), and this is initiated by Lemonator AND user has never touched this. */
  z?: true
  /** If this is marked to be in reconsiliation (selvitettävä), the possible related Message from accountant */
  m?: string
  /** If this is marked to be in reconsiliation (selvitettävä), the maksun saaja. */
  w?: string
  /** The bot (or automatic) kirjausdata */
  b?: TositeAutokirjausdataMap
}

export interface KuitinKuva {
  /** Type: jpg, png and so forth */
  t: string
  /** Order of the image */
  o: number
  /** Removed/Deleted or not? */
  d: boolean
}

export interface KuitinMuutoksenKuva extends KuitinKuva {
  base64Encoded: string // Base 64 encoded image
  ut?: 'heif' | 'webp'
}

export interface KuitinMuutosWrapper {
  /** Itse muutos */
  c: KuitinMuutos
  /** Kuitin täysi uri */
  u: string
}

export interface KuitinMuutos extends Kuitti {
  // key: string,                    //The key of this CHANGE SET!
  // receiptKey: string,             //The key of the RECEIPT that this change set changes.
  // companyId: number,              //The key of the company this change set belongs to.
  // month: number,
  // year: number,
  /** Aseta trueksi jos haluat, ettei kirjanpitäjän käyttöliittymä näytä tätä uutena tositteena */
  merkitseJoLadatuksi: boolean
  /** Timestamp that has been set in the cell phone, in UTC. */
  // t: string,
  /** Timestamp that has been set when server received the change set in UTC. */
  // st: string,
  /** Was receipt removed, deleted? */
  r: boolean
  /** The firebase user id that made the change (uid) */
  u: string
  /** Images */
  i: { [key: string]: KuitinMuutoksenKuva }
  /** Milloin käyttäjä tallensi kuitin kännykässä, UTC ISO timestamp */
  t: string
  /** UTC millisekuntia epochista, unix timestamp siis milloin firebase kirjoitti entryn omaan kantaansa */
  st: number
}

export interface Maksutapa {
  /** Onko maksutapa default vai ei? */
  d: number

  /** Tunniste firman sisällä, johon käyttäjä kuuluu */
  i: number

  /** Maksutapojen järjestys */
  o: number

  /** Nimi listauksessa */
  l: string

  /** Nimi jossain muualla */
  v: string

  /** Base64 encoodattu kuva */
  img: string

  /** Aktiivinen */
  a: boolean
}

export interface Kayttaja {
  /** ALV-portaat järjestyksessä, kuin ne ovat prosessissa erotettuna pilkulla, default ensin, esim. 100,0,50 */
  a: string
  /** asiakasId */
  c: number
  /** Maksutapojen tunnukset siinä järjestyksessä, kuin ne ovat prosessissa erotettuna pilkulla */
  p: string
  /** Prosessin osien otsikot */
  pt: { [prosessinAvain: string]: string }
  /** Rooli, aina s vanhoissa kännyissä */
  r: 's'
  /** aktiivinen, onko käyttäjä aktiivinen vai ei */
  ak: boolean
  /** Yrityksen tyyppi */
  ct: Yritysmuoto
  /** Selvitettävien näkyvyys */
  s: SelvitettavienNakyvyys
}

export type TositeTyyppi = 'osto' | 'myynti' | 'palkka' | 'tiliote'

export enum TositeAutokirjaustyyppi {
  OMALLA_RAHALLA = 'OMALLA_RAHALLA',
}

/**
 * TODO: FIXME:
 * 1. Remove y and all associated code.
 * 2. remove pvm and localPvm, change to p: NumberDate
 *  2.1 First, add the new property and start to fill it in code
 *  2.2 Deploy the code
 *  2.3 Create a migration script to populate the new property
 *  2.4 Start to use the new property in code
 *  2.5 When all code uses the new property, the old fields can be deleted
 */
export interface FirestoreTosite {
  avain: string
  type: 'tosite' | 'einvoice' | 'payment'
  pvm: Timestamp
  localPvm: LocalDate
  p: NumberDate
  /** Old version, contains only absolute numbers */
  summa: number
  /** New version, contains the original real number value of the receipt */
  sum: number
  selite: string
  userApiMessage?: string
  maksutapa: number
  alvVahennysoikeus: number
  kayttajaUid: string
  tallennettuKannykassa: Timestamp
  vastaanotettuPalvelimelle: Timestamp
  paivitetty: Timestamp
  lahde: 'kannykka' | 'kannykka-v2' | 'web' | 'holvi' | 'kirjanpito' | 'holviapi' | 'sahkoinenlasku' | 'integration-api'
  kuvakansio: string
  kuvat: { [key: string]: FirestoreTositteenKuva }
  alkuperaiset?: { [key: string]: FirestoreTositteenAlkuperainenTiedosto }
  poistettu: boolean
  paivitykset?: { [key: string]: boolean }
  /** Is this receipt the result of combining multiple receipts? */
  // y?: FirestoreTosite[]
  /** Is this receipt locked? */
  l?: true
  /** Is this receipt in reconsiliation (selvitettävä)? */
  x?: true
  /** If this is marked to be in reconsiliation (selvitettävä), and this is initiated by Lemonator */
  z?: true
  /** If this is marked to be in reconsiliation (selvitettävä), the possible related Message from accountant. */
  m?: string
  /** If this is marked to be in reconsiliation (selvitettävä), the maksun saaja. */
  w?: string
  /** If this is marked to be in reconsiliation (selvitettävä), the additional data from tilitapahtuma. */
  c?: string
  /** The bot (or automatic) kirjausdata. */
  b?: TositeAutokirjausdataMap
  /** The data that can be used to attach this receipt to tilitapahtuma */
  tagTilitapahtumat?: string[]

  /** Deprecated. Electronic invoice, Viitenumero */
  ev?: string
  /** Deprecated. Electronic invoice, Laskuttajan nimi */
  el?: string
  /** Deprecated. Electronic invoice, summa */
  es?: number

  /** The approval status of the invoice if it needs one. */
  einvoiceApprovalStatus?: 'pending-approval' | 'approved' | 'rejected' | 'approval-disabled'
  einvoiceApprovals?: {
    [uid: string]: {
      approved: Timestamp
      firstName: string
      lastName: string
    }
  }
  /** The forwarding status of the invoice */
  einvoiceForwardingStatus?: 'waiting-to-be-forwarded' | 'forwarded' | 'forwarding-disabled'

  /** If created from our own invoice, the avain of the customer _sending_ the invoice */
  einvoiceCreatedFromOurInvoiceAsiakasAvain?: string
  /** If created from our own invoice, the id of the customer _sending_ the invoice */
  einvoiceCreatedFromOurInvoiceAsiakasId?: string
  /** If created from our own invoice, the avain of the juurilasku of the customer _sending_ the invoice */
  einvoiceCreatedFromOurInvoiceJuurilaskuAvain?: string
  /** If created from our own invoice, the avain of the kasiteltava lasku of the customer _sending_ the invoice */
  einvoiceCreatedFromOurInvoiceKasiteltavaAvain?: string

  /** Shared by different types, eg electronic invoice */
  viitenumero?: string
  laskunumero?: string

  /** Shared by different types, eg electronic invoice */
  /** This is the beneficiary, the one receiving the money, payee */
  seller?: string
  sellerId?: string

  /** Key of the invoice sender entity in Lemon Tree database */
  toimittajaAvain?: string

  /** Key of the kirjanpidon projekti this receipt is linked to */
  projektiAvain?: string

  /** Mobiilin AI-moodin kululuokka */
  kategoria?: string

  /** Shared by different types, eg electronic invoice */
  dueDate?: NumberDate

  /** When the einvoice was paid? */
  paymentDate?: NumberDate

  /** When the einvoice goods were delivered? */
  deliveryDate?: NumberDate

  /** Invoice date */
  invoiceDate?: NumberDate

  /** The ISO currency of the receipt, if unavailable then EUR */
  currency?: string

  /** The status of the payment */
  paymentStatus?: PaymentStatus

  /** The rejection info of the payment */
  paymentRejection?: PaymentRejection

  /** When was sent to payment */
  paymentSentToGateway?: Timestamp

  /** The iban where the payment is going */
  iban?: string

  /** The bic where the payment is going */
  bic?: string

  // /** The users who have approved payments */
  // paymentApprovals?: {
  //   [uid: string]: {
  //     approved: Timestamp
  //     firstName: string
  //     lastName: string
  //   }
  // }

  /**
   * Vahvistetun maksun vahvan tunnistautumisen session avain (kts. historiasta aiemmat vahvistukset).
   */
  paymentStrongAuthSessionKey?: string

  /**
   * Käyttäjä id joka suoritti vahvan tunnistautumisen maksun vahvistamisessa (kts. historiasta aiemmat vahvistukset).
   */
  paymentStrongAuthUid?: string

  /** What maksutapa was used to do the payment? */
  paymentMaksutapa?: number

  /** The information of the payment */
  maksutiedot?: TositteenMaksutiedot

  /** If created by external system, their idetifier */
  ulkoinenTunniste?: string

  /** LLM:n tositteesta ekstraktoima tekstisisältö, syntyy kirjausehdotuksen sivutuotteena */
  llmSisalto?: TositteenLlmSisalto

  /**
   * Sen AI-poiminnan avain, jolla tosite esitäytettiin (llm_tosite_luku_tilasto.poiminta_avain).
   * Kirjoitetaan vain jos puuttuu; uudelleenluku ennen ensitallennusta korvaa avaimen clientissä.
   */
  aiPoimintaAvain?: string
}

/** Tallentaja järjestelmän tekemille tallennuksille, sama kuin laskujen historiassa */
export const TOSITTEEN_JARJESTELMATALLENTAJA = 'lemonator_system'

/**
 * Tositteen historiakopio (customers/{asiakasAvain}/tositteet/{tositeAvain}/historia/{id}).
 * Tallentaja kirjoitetaan vain historiaan: tositteen kayttajaUid ei kerro luotettavasti, kuka tallensi.
 * Marraskuuta 2026 vanhemmista merkinnöistä tallentajan kentät puuttuvat.
 */
export interface FirestoreTositteenHistoria extends FirestoreTosite {
  /** Tallennuksen tehneen Lemonaid-käyttäjän tai kirjanpitäjän uid, järjestelmän tallennuksessa TOSITTEEN_JARJESTELMATALLENTAJA */
  tallentaja: string
  /** Emuloivan käyttäjän uid, kun tallennus tehtiin emuloidussa sessiossa */
  tallentaja_euid?: string
}

/**
 * LLM:n tositteesta ekstraktoima tekstisisältö (tuoterivit ja hinnat + ALV-erittely).
 * Wrapperi eikä paljas string, jotta myöhempi rakenteistaminen saa paikan.
 */
export interface TositteenLlmSisalto {
  teksti: string
  luotu: Timestamp
  malli: string
}

/**
 * Maksun tiedot
 */
export interface TositteenMaksutiedot {
  /**
   * Tunniste, jolla sisäinen järjestelmä yksilöi maksun (tositteella ja maksulla samat ID:t)
   */
  identifier: string
  /**
   * Määrä
   */
  amount: number
  /**
   * ISO 4217 valuutta
   */
  valuutta: string
  /**
   * Mille tilille
   */
  iban: string
  /**
   * BIC-koodi
   */
  bic: string
  /**
   * Maksun saaja
   */
  maksunSaajanNimi: string
  /**
   * Viesti
   */
  message: string | null
  /**
   * Viitenumero
   */
  reference: string | null
  /**
   * Eräpäivä
   */
  dueDate: NumberDate
  /**
   * Onko sala-maksu?
   */
  isSalary: boolean
  /**
   * Onko testaukseen käytettävä maksu
   */
  isTestPayment?: boolean
  /**
   * Toimituspäivämäärä
   */
  deliveryDate: NumberDate
}

/**
 * Firestore: customers/{asiakasAvain}/payments-to-approve/{paymentStrongAuthSessionKey}
 */
export interface VahvistettavatMaksut extends BaseEntity {
  vahvistettu: Timestamp
  paymentStrongAuthUid: string
  paymentStrongAuthSessionKey: string
  /**
   * Pyydetty maksuajankohta
   */
  paymentDueType: PaymentDueType
  /**
   * Kaikki maksut, jotka on alun perin asiakkaan toimesta vahvistettu maksettavaksi
   */
  maksut: string[]
  /**
   * Maksut, jotka tulee edelleen saattaa maksuun.
   * Lähtökohtaisesti samat, kuin maksut-listassa, mutta jos osa maksuista hylätään maksujärjestelmän toimesta,
   * jätetään ne keskeneräiseksi uudelleenyritystä varten.
   */
  keskeneraisetMaksut: string[]
  /**
   * Maksutili, jolta maksut veloitetaan
   */
  paymentConfigIdentifier: string
}

export enum PaymentStatus {
  // ODOTTAA_HYVAKSYNTAA = 'o',
  // HYVAKSYTTY = 'h',
  AVOIN = 'a',
  ERAANTYNYT = 'e',
  MAKSUSSA = 'n',
  MAKSETTU = 'm',
  ASIAKAS_HYLKASI = 'ah',
  PANKKI_HYLKASI = 'p',
  MAKSETTU_TOISAALLA = 't',
  KASITELTY = 'k',
}

type TositeAutokirjausdataMap = Partial<Record<TositeAutokirjaustyyppi, TositeAutokirjausdata>>

export interface TositeAutokirjausdata {
  /** Automaattikirjauksen tyyppi */
  t: TositeAutokirjaustyyppi

  // BELOW LATER!!
  /** Osuus tositteesta */
  // o: number
  /** Osuuden ALV-kanta */
  // a: DATATYPEMISSING
  /** Osuuden käyttötarkoitus */
  // k: DATATYPEMISSING
}

export interface FirestoreTositteenAlkuperainenTiedosto {
  avain: string
  nimi: string
  kuvakansio: string
  fileEnding: string
  kasitelty: boolean
  poistettu?: true
  jarjestys?: number
  lukittu?: 1
  lahde?: 'holviapi' | 'kannykka-v2'
}

export interface FirestoreTositteenKuva {
  avain: string
  type: 'jpg' | 'pdf'
  jarjestys: number
  poistettu: boolean
  alkuperaisenAvain?: string
  lukittu?: 1
}

export interface RealtimeDbAvainToFirestoreAvainMappaus {
  firestoreKey: string
}

export interface FirestoreAvainToRealtimeDbAvainMappaus {
  realtimeDbUrl: string
  realtimeDbKey: string
}

export interface OstolaskujenHakupyynto {
  vapaa: string
  skip: number
  limit: number
  orderBy: { column: 'sum' | 'dueDate'; direction: 'asc' | 'desc' }
  tilat: PaymentStatus[]
}

export interface OstolaskujenHakuvastaus extends ErrorResponse<'unauthorized' | 'invalid-query'> {
  queryTimeMillis: number
  tulokset: FirestoreTosite[]
}

export interface InspectFileRequest {
  /** The location where uploaded file is */
  bucketLocationUri: string
  /** The UNRELIABLE file name given by user */
  name: string
}

export interface InspectFileResponse {
  /** The detected file type */
  fileType: FileType
  /** How many pages the file has */
  pages: number
}

export interface ReplikoiTositeTyojonoData {
  asiakasId: string
  kuittiAvain: string
  created: Timestamp
  /** Tallennuskanava AI-poiminnan tilastoa varten; puuttuu vanhoista ja pelkän replikoinnin töistä. */
  kanava?: 'mobiili' | 'web'
  /** Tallennuksen uusi toimittaja AI-poiminnan tilastoa varten; puuttuu, kun tallennus ei luonut eikä yhdistänyt uutta toimittajaa. */
  luotuToimittaja?: TallennuksessaLuotuToimittaja
}

/** Tallennuksen uudesta toimittajasta luotu tai sen tunnisteella yhdistetty rekisterin toimittaja. */
export interface TallennuksessaLuotuToimittaja {
  avain: string
  /** Käyttäjän lähettämä nimi, joka voi poiketa AI:n ehdotuksesta. */
  nimi: string
  /** Käyttäjän lähettämät tunnisteet normalisoituina molempiin suomalaisiin muotoihin. */
  tunnisteet: string[]
}

/** AI-poiminnan ehdotus matkalla Postgresin llm_tosite_luku_tilasto-tauluun; kirjoitetaan myös virhetapauksissa. */
export interface LlmTositeLukuTilastoTyojonoData {
  poimintaAvain: string
  asiakasId: string
  asiakasAvain: string
  kayttajaUid: string
  kuvakansio: string
  kuvia: number
  malli: string | null
  promptTunniste: string
  virhe: string | null
  vastaus: Omit<TositeAiVastaus, 'e' | 'poimintaAvain'>
  inputTokenit: number | null
  outputTokenit: number | null
  created: Timestamp
}

/** Korvaa saman poiminta-avaimen ehdotustyön, jotta ehdotus ja sen poisto eivät voi käsittelyssä ohittaa toisiaan. */
export interface LlmTositeLukuTilastoPoistoTyojonoData {
  poimintaAvain: string
  asiakasId: string
  poistettu: true
  created: Timestamp
}

export interface TositeAiKuva {
  // Kuvan sivunavain (mobiilisovelluksen imageId). Storage-polku: {asiakasId}/{kuvakansio}/{sivunAvain}.{tiedostopaate}.
  sivunAvain: string
  tiedostopaate: string
  // Kuvan kansio, jos eri kuin pyynnön kuvakansio (webissä yhdistetyn tositteen sivut ovat alkuperäisissä kansioissaan).
  kuvakansio?: string
}

export interface TositeAiPyynto {
  // Tositekuvien kansio kutsujan asiakaskansiossa (createReceipt luo; sama kaikille kuitin kuville).
  kuvakansio: string
  // Kuitin kaikki kuvat; kaikki lähetetään mallille samassa kutsussa (speksi 7.5: AI-poimintaan menevät kaikki kuvat).
  kuvat: TositeAiKuva[]
}

// 'unreadable-image': malli arvioi kuvat liian epäselviksi luotettavaan
// poimintaan — mobiili jatkaa lomakkeelle ilman esitäyttöä ja näyttää
// maininnan, muut virheet ohjaavat "Käsittele myöhemmin" -polulle.
export interface TositeAiVastaus extends ErrorResponse<'missing-data' | 'unknown-error' | 'unreadable-image'> {
  paivamaara: string | null
  // Etumerkillinen kuten FirestoreTosite.sum: hyvitys (raha palautuu asiakkaalle) on negatiivinen.
  summa: number | null
  hyvitys: boolean
  valuutta: string | null
  toimittaja: string | null
  businessId: string | null
  businessIdType: 'y-tunnus' | 'vat' | null
  /** Rekisteriosuman avain. Puuttuessa toimittaja + businessId ovat tallentamaton ehdotus, jonka client vahvistaa ja tallennus luo. */
  toimittajaAvain: string | null
  // Kuitilla näkyvän maksukortin neljä viimeistä numeroa — koko korttinumeroa
  // ei koskaan palauteta.
  maksukorttiViimeiset4: string | null
  // Mallin perustelu suomeksi: mistä kohdista arvot poimittiin ja miksi
  // toimittajaosuma valittiin tai jätettiin valitsematta.
  reasoning: string | null
  raakaVastaus: string | null
  /** Tilastorivin avain; client välittää sen tallennuspyynnössä (aiPoimintaAvain), jotta ehdotus ja lopputulos voidaan yhdistää. */
  poimintaAvain: string
}

export type TositeLaji = 'tositteet' | 'ostolaskut' | 'molemmat'

export interface TositteetHakuPyynto {
  vapaahaku?: string
  alkuPvm?: NumberDate
  loppuPvm?: NumberDate
  maksutavat?: number[]
  toimittajaAvaimet?: string[]
  projektiAvaimet?: string[]
  vapaahakuToimittajaAvaimet?: string[]
  vapaahakuProjektiAvaimet?: string[]
  tositelaji?: TositeLaji
  /** Sivun koko, maksimi 200 */
  ylaraja?: number
  /** Nollapohjainen sivunumero */
  sivu?: number
  /** Vain mobiilin haku: rajaa pois myynti-, tiliote- ja palkkatositteet. Puuttuva = näytetään (vanhat sovellusversiot). */
  vainOstotositteet?: boolean
}

export type TositeHakutulosLaji = 'o' | 'm' | 't'

/**
 * Sisältää vain tositelistauksen tarvitsemat kentät yhden merkin avaimilla,
 * jotta hakuvastaus pysyy mahdollisimman kevyenä (kenttien nimet toistuvat jokaisella rivillä).
 */
export interface TositeHakutulos {
  /** Tositteen avain (FirestoreTosite.avain) */
  a: string
  /** Tositteen päivämäärä NumberDate-muodossa vvkkpp (FirestoreTosite.p) */
  p?: NumberDate
  /** Myyjän tai toimittajan nimi (FirestoreTosite.seller ?? FirestoreTosite.el) */
  n?: string
  /** Summa (FirestoreTosite.sum) */
  s?: number
  /** Maksutavan numeerinen tunniste (FirestoreTosite.maksutapa) */
  m?: number
  /** Selite / lisätiedot (FirestoreTosite.selite) */
  e?: string
  /** Kirjanpidon projektin avain (FirestoreTosite.projektiAvain) */
  j?: string
  /** Toimittajarekisterin avain (FirestoreTosite.toimittajaAvain) */
  t?: string
  /** Tositelaji: 'o' = sähköinen ostolasku (FirestoreTosite.type === 'einvoice'), 'm' = maksu (type === 'payment'), 't' = muu tosite */
  l?: TositeHakutulosLaji
  /** Kuvien lukumäärä, puuttuu kun kuvia ei ole (sama kuin MobiiliKuittiRivi.ku) */
  ku?: number
  /** Listan pikkukuvan lähde (sama kuin MobiiliKuittiRivi.kk1) */
  kk1?: MobiiliKuittiKansikuva
}

export interface TositteetHakuPyyntoLemonator extends TositteetHakuPyynto {
  asiakasAvain: string
}

export interface TositteetHakuVastaus extends ErrorResponse<'unauthorized' | 'invalid-query' | 'unknown-error'> {
  tositteet: TositeHakutulos[]
  kokonaismaara: number
}
